import React from 'react';

const UserManagementSVG = () =>
  <svg height="53px" width="53px" version="1.1" viewBox="0 0 53 53">
    <g fill="none" stroke="none" strokeLinecap="square" strokeWidth="1">
      <g transform="translate(-195.000000, -258.000000)">
        <g transform="translate(157.000000, 115.000000)">
          <g transform="translate(-1.000000, 107.000000)">
            <g transform="translate(39.000000, 29.000000)">
              <g transform="translate(0.000000, 6.000000)">
                <g transform="translate(0.000000, 0.509100)">
                  <mask fill="white">
                    <polygon points="0 26.7456 0 53 52.509 53 52.509 26.7456 52.509 0.4912 0 0.4912" />
                  </mask>
                  <path
                    d="M52.509,26.7452 C52.509,12.2452 40.755,0.4912 26.255,0.4912 C11.755,0.4912 0,12.2452 0,26.7452 C0,41.2452 11.755,53.0002 26.255,53.0002 C40.755,53.0002 52.509,41.2452 52.509,26.7452"
                    fill="#ECECEC"
                  />
                </g>
                <g
                  fill="#FFFFFF"
                  stroke="#222228"
                  strokeWidth="1.5"
                  transform="translate(18.000000, 12.000000)"
                >
                  <path d="M17.9454092,6.41504782 C16.8573821,2.63069983 13.3871372,0.134066368 9.26170135,0.0995258271 C4.20259152,0.0563501512 0.0642029894,4.32750389 0.0231860973,9.38661371 L0.0231860973,27.9618689 L11.3006726,27.9618689 L11.3006726,20.6641003 L15.5729058,20.6641003 C16.3327977,20.8454381 17.0182115,20.2291053 17.2707892,19.468134 L17.2707892,14.6939837 L19.9250139,14.6939837 L17.9454092,6.41504782 Z" />
                </g>
                <g stroke="#EB5424" transform="translate(19.000000, 13.000000)">
                  <path
                    d="M12.2583,10.7403 L14.1543,11.0243 L14.5463,8.4113 L12.6623,8.1293 C12.6103,7.8243 12.5313,7.5213 12.4083,7.2233 C12.3003,6.9613 12.1663,6.7163 12.0143,6.4883 L13.1863,4.9923 L11.1053,3.3643 L9.9253,4.8703 C9.3753,4.6713 8.7863,4.5923 8.1883,4.6353 L7.4563,2.8633 L5.0143,3.8713 L5.7463,5.6443 C5.2903,6.0363 4.9273,6.5103 4.6773,7.0413 L2.7703,6.8053 L2.4453,9.4283 L4.3433,9.6623 C4.3973,9.9293 4.4733,10.1953 4.5813,10.4553 C4.7033,10.7513 4.8603,11.0203 5.0363,11.2713 L3.8933,12.8103 L6.0153,14.3853 L7.1633,12.8393 C7.6863,13.0143 8.2393,13.0843 8.8013,13.0433 L9.5423,14.8373 L11.9843,13.8283 L11.2443,12.0353 C11.6703,11.6693 12.0103,11.2303 12.2583,10.7403 Z"
                    transform="translate(8.495800, 8.850300) rotate(23.000000) translate(-8.495800, -8.850300) "
                  />
                  <path d="M7.8218,7.2091 C6.9208,7.5811 6.4928,8.6121 6.8638,9.5131 C7.2368,10.4141 8.2678,10.8421 9.1688,10.4701 C10.0688,10.0991 10.4978,9.0671 10.1258,8.1661 C9.7538,7.2661 8.7218,6.8371 7.8218,7.2091 Z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>;

export default UserManagementSVG;



// WEBPACK FOOTER //
// ./src/svg/UserManagementSVG.js